























































































































































import Vue from 'vue'
import { genesisIdToNetwork } from '../utils'

export default Vue.extend({
    data: () => {
        return {
            address: '',
            account: {
                entity: null as Connex.Thor.Account | null,
                error: null as Error | null
            },
            code: {
                entity: null as Connex.Thor.Account.Code | null,
                error: null as Error | null,
                loading: false
            },
            sponsor: {
                addr: '',
                error: null as Error | null,
            },
            master: {
                addr: '',
                error: null as Error | null,
            },
            openDeposit: false
        }
    },
    watch: {
        '$state.chainStatus'() {
            this.reload()
        }
    },
    methods: {
        async reload() {
            this.loadBalance()
            this.loadMaster()
            this.loadSponsor()
        },
        async loadBalance() {
            const acc = this.$connex.thor.account(this.address)
            try {
                this.account.entity = await acc.get()
                this.account.error = null
            } catch (err) {
                this.account.error = err
            }
        },
        async loadMaster() {
            try {
                const method = this.$connex.thor
                    .account(prototypeAddress)
                    .method(masterJsonABI)

                if (method.cache) {
                    method.cache([this.address])
                }
                const out = await method
                    .call(this.address)

                const addr = out.decoded![0]
                this.master.addr = addr === zeroAddress ? 'N/A' : addr
                this.master.error = null
            } catch (err) {
                this.master.error = err
            }
        },
        async loadSponsor() {
            try {
                const method = this.$connex.thor
                    .account(prototypeAddress)
                    .method(currentSponsorJsonABI)

                if (method.cache) {
                    method.cache([this.address])
                }

                const out = await method
                    .call(this.address)

                const addr = out.decoded![0]
                this.sponsor.addr = addr === zeroAddress ? 'N/A' : addr
                this.sponsor.error = null
            } catch (err) {
                this.sponsor.error = err
            }
        },
        async loadCode() {
            try {
                this.code.loading = true
                this.code.entity = await this.$connex.thor.account(this.address).getCode()
                this.code.error = null
            } catch (err) {
                this.code.error = err
            } finally {
                this.code.loading = false
            }
        }
    },
    computed: {
        price() { return this.$state.price },
        isMainNet() { return genesisIdToNetwork(this.$connex.thor.genesis.id) === 'main' }
    },
    created() {
        this.address = this.$route.params.address.toLowerCase()
        this.reload()
        if (this.$route.name === 'deposit') {
            this.openDeposit = true
        }
    }
})

const prototypeAddress = '0x000000000000000000000050726f746f74797065'
const zeroAddress = '0x0000000000000000000000000000000000000000'

const masterJsonABI = {
    constant: true,
    inputs: [
        {
            name: '_self',
            type: 'address'
        }
    ],
    name: 'master',
    outputs: [
        {
            name: '',
            type: 'address'
        }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
}

const currentSponsorJsonABI = {
    constant: true,
    inputs: [
        {
            name: '_self',
            type: 'address'
        }
    ],
    name: 'currentSponsor',
    outputs: [
        {
            name: '',
            type: 'address'
        }
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function'
}
